/**
 * Frontend-Zugriffssteuerung für Tenant-Verwaltung:
 * Tenants-Tab und Tenant-Zuweisung im Benutzer-Dialog sind nur für
 * die hier gelisteten Benutzer (per E-Mail) sichtbar.
 */

import AdminData from "../backend/dataservices/AdminData";
import User from "../backend/User";

const TENANT_ADMIN_EMAILS = [
    'patrick.farnkopf.ext@siemens.com',
    'stefan.schoenmann@siemens.com',
];

export function isTenantAdminFromUsers(users) {
    if (!Array.isArray(users)) return false;
    const me = users.find(u => u.U_ID === User.getUserID());
    return !!me && TENANT_ADMIN_EMAILS.includes((me.U_Email || '').toLowerCase());
}

let cachedPromise = null;

export function fetchIsTenantAdmin() {
    if (!cachedPromise) {
        cachedPromise = AdminData.getUsers()
            .then(isTenantAdminFromUsers)
            .catch(() => false);
    }
    return cachedPromise;
}
